export default __webpack_public_path__ + "static/media/5_Still.c4b703c4.jpg";